
import {jwtServerInstance} from "../index";
import qs from	'qs'

//查询所有数据字典项
export const getAllB2cGoods = () => {
    return jwtServerInstance.request({
        url:'/b2cgoods/all',
        method:'post'
    })
}

//参数配置列表查询接口
export const getB2cGoods = (
            goodsTitle,
            goodsImgUrl,
            goodsUrl,
            buyPrice,
            buyNumbers,
            showPrice ) => {
    return jwtServerInstance.request({
        url:'/b2cgoods/query',
        method:'post',
        data:qs.stringify({
            goodsTitle,
            goodsImgUrl,
            goodsUrl,
            buyPrice,
            buyNumbers,
            showPrice
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateB2cGoods = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cgoods/update',
        method:'post',
        data:dialogForm
    })
}

//新增一条b2c_goods数据记录
export const addB2cGoods = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cgoods/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条b2c_goods数据记录
export const deleteB2cGoods = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cgoods/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}